import loadingLogo from './../images/billy-logo.png'

export default function Loader(){
    return( 
        <div className="lds-dual-ring" >
            <img 
                className="menu-icon animate-flicker" 
                alt="logo" 
                src={loadingLogo}
            />
        </div>
    )
}